import { render } from "./Navi.vue?vue&type=template&id=3e0b753c&scoped=true"
import script from "./Navi.vue?vue&type=script&lang=js"
export * from "./Navi.vue?vue&type=script&lang=js"

import "./Navi.vue?vue&type=style&index=0&id=3e0b753c&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0b753c"]])

export default __exports__